import { Button } from '@msdyn365-commerce-modules/utilities';
import { IGridSettings, IImageData, IImageSettings, Image, IRequestContext } from '@msdyn365-commerce/core';

import React from 'react';

export interface SubCategoryTileProps {
    subCategoryLinkText: string;
    subCategoryName?: string;
    subCategoryDescription?: string;
    imageUrl?: string;
    altText?: string;
    subCategoryDetailsLink?: string;
    imageSettings?: IImageSettings;
    fallbackImage?: string;
    context?: IRequestContext;
}

const SubCategoryCard = ({
    subCategoryLinkText,
    subCategoryName,
    imageUrl,
    altText,
    subCategoryDetailsLink,
    imageSettings,
    fallbackImage,
    subCategoryDescription,
    context
}: SubCategoryTileProps) => {
    return (
        <div className='subcategory-card-container text-center'>
            <div className='subcategory-card h-100'>
                <div className='subcategory-card-body'>
                    <div className='subcategory-card-image'>
                        {renderSubCategoryImage(imageSettings, context?.gridSettings, imageUrl, altText, fallbackImage, context)}
                    </div>
                    <div className='subcategory-card-title'>{subCategoryName}</div>
                    <div className='subcategory-card-'>
                        <p className='subcategory-description'>{subCategoryDescription}</p>
                    </div>
                </div>
                <div className='subcategory-card-footer'>
                    <Button className='subcategory-link-btn' href={subCategoryDetailsLink}>
                        {subCategoryLinkText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

function renderSubCategoryImage(
    imageSettings?: IImageSettings,
    gridSettings?: IGridSettings,
    imageUrl?: string,
    altText?: string,
    fallbackImage?: string,
    context?: IRequestContext
): JSX.Element | null {
    if (!imageUrl || !gridSettings || !imageSettings) {
        return null;
    }
    const img: IImageData = {
        src: imageUrl,
        altText: altText ? altText : ''
    };
    const imageProps = {
        gridSettings,
        imageSettings,
        fallBackSrc: fallbackImage
    };
    return <Image {...img} {...imageProps} loadFailureBehavior='empty' requestContext={context} />;
}

export default SubCategoryCard;
